export const C_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_HOUR_FORMAT_DB = `${C_DATE_FORMAT}THH:mm:00.000Z`;

export const EVENT_TARGETS = {
  FEED: 'FEED',
  EVENT_REWARD: 'EVENT_REWARD',
  USER: 'USER',
};

export const FREQUENCY = 'FREQUENCY';
export const LIMIT_ACHIEVEMENT = 'LIMIT_ACHIEVEMENT';
export const TIME_ACHIEVEMENT = 'TIME_ACHIEVEMENT';
export const EQUALS = 'EQUALS';

export const CONDITIONS_NOT_TARGET_REWARD = [FREQUENCY, LIMIT_ACHIEVEMENT, TIME_ACHIEVEMENT];
export const CONDITIONS_TARGET_REWARD = [EQUALS];

export const EVENT_STATUS = {
  UPCOMING: 'UPCOMING',
  RUNNING: 'RUNNING',
  FINISHED: 'FINISHED',
  UNKNOWN: 'UNKNOWN',
};

export const UNLIMITED_CHARACTERS = '-';
export const UNLIMITED_NUMBER = -1;
